import {useRef, useState} from 'react';
import {
  SetFiltersWithoutToggleType,
  usePotentialFilters,
} from './usePotentialFilters';

export const useOpenFilterFlyout = () => {
  const [openedFlyoutSlug, setOpenedFlyoutSlug] = useState<
    string | undefined
  >();
  const tempFilters = useRef<SetFiltersWithoutToggleType>([]);
  const {filters: activeFilters, setFiltersWithoutToggle} =
    usePotentialFilters();

  /**
   * sizeGroups filter holds several filters, and we get the values using the second function params "filtersSlugs",
   * for the rest the values are obtained using the param "flyoutSlug"
   */
  const openFilterFlyout =
    (flyoutSlug: string) => (filtersSlugs?: string[]) => {
      const slugs = Array.isArray(filtersSlugs) ? filtersSlugs : [flyoutSlug];
      tempFilters.current = slugs.map(slug => ({
        filterSection: slug,
        filterValues: activeFilters.get(slug),
      }));
      setOpenedFlyoutSlug(flyoutSlug);
    };

  const submitFilterFlyout = () => {
    tempFilters.current = [];
    setOpenedFlyoutSlug(undefined);
  };

  const hideFilterFlyout = () => {
    setFiltersWithoutToggle(tempFilters.current);
    submitFilterFlyout();
  };

  return {
    openFilterFlyout,
    hideFilterFlyout,
    submitFilterFlyout,
    openedFlyoutSlug,
  };
};
